import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=5895e1fa&"
import script from "./videoPage.vue?vue&type=script&lang=js&"
export * from "./videoPage.vue?vue&type=script&lang=js&"
import style0 from "./videoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports